<app-bool-value-chooser
  [title]="'ADDITIONAL_INCOME.FREELANCE_GROUP.STEUERNUMMER.QUESTION'"
  [templateRef]="steuernummer"
  [selectedOption]="vatDeclaration.has_steuernummer"
  (changeValueEvent)="handleFieldsValue('has_steuernummer', $event)"
  [titleTooltip]="'ADDITIONAL_INCOME.FREELANCE_GROUP.STEUERNUMMER.TOOLTIP_TITLE' | translate"
  [messageTooltip]="'ADDITIONAL_INCOME.FREELANCE_GROUP.STEUERNUMMER.TOOLTIP_TEXT' | translate"
></app-bool-value-chooser>

<div class="mb-30">
  <app-section-title
    [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.DECLARATION_TYPE.QUESTION'"
    [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.DECLARATION_TYPE.TOOLTIP_TITLE' | translate"
    [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.DECLARATION_TYPE.TOOLTIP_TEXT' | translate"
  ></app-section-title>
</div>
<mat-radio-group
  name="declaration_type"
  [(ngModel)]="vatDeclaration.declaration_type"
  (ngModelChange)="handleOkButton($event)"
>
  <div>
    <mat-radio-button [value]="declarationTypes.BUSINESS">
      <span>{{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.DECLARATION_TYPE.SMALL" | translate }}</span>
    </mat-radio-button>
  </div>
  <div>
    <mat-radio-button [value]="declarationTypes.VAT_INCOME">
      <span>{{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.DECLARATION_TYPE.BIG" | translate }}</span>
    </mat-radio-button>
  </div>
</mat-radio-group>

@if (vatDeclaration.declaration_type === declarationTypes.BUSINESS) {
  <div class="input-container mb-50 no-border">
    <div class="row">
      <div class="column">
        <app-form-input
          [errors]="additionalIncomeService.getError('income_sum')"
          [label]="('ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.THIS_YEAR_INCOME_LABEL' | translate) + ' ' + statementYear"
          [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.THIS_YEAR_INCOME_PLACEHOLDER'"
          [(model)]="vatDeclaration.income_sum"
          (modelChange)="validateIncomeSum($event)"
          [classB2B]="'total_payments_input_pit'"
          [isCurrency]="false"
        ></app-form-input>
        <app-validator-error-message
          [epValidator]="additionalIncomeService.epValidator"
          [index]="index"
          [fieldName]="additionalIncomeService.VALIDATOR_KEYS.income_sum"
        ></app-validator-error-message>
      </div>
      <div class="column">
        <app-form-input
          [errors]="additionalIncomeService.getError('last_year_income')"
          [label]="
            ('ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.LAST_YEAR_INCOME_LABEL' | translate) + ' ' + (statementYear - 1)
          "
          [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.LAST_YEAR_INCOME_PLACEHOLDER'"
          [(model)]="vatDeclaration.last_year_income"
          (modelChange)="validateLastYearIncome($event)"
          [classB2B]="'total_withdrawals_input_pit'"
          [isCurrency]="false"
        ></app-form-input>
        <app-validator-error-message
          [epValidator]="additionalIncomeService.epValidator"
          [index]="index"
          [fieldName]="additionalIncomeService.VALIDATOR_KEYS.last_year_income"
        ></app-validator-error-message>
      </div>
    </div>
    @if (incomeSumError || lastYearIncomeError) {
      <div class="deductions-info warning is_icon border-warning error-box">
        <div class="deductions-info__wrap top">
          <div class="row first-row">
            <div class="column">
              <div class="deductions-info__toltip-wrap alert_wrap">
                <img src="../../../../../../assets/svg/error_icon.svg" class="alert_icon" />
              </div>
              <div class="deductions-info__wrap-text first-row-content">
                <p class="deductions-info__text p-16">
                  {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.OVER_THE_LIMIT" | translate }}
                </p>
              </div>
            </div>
          </div>
          <div class="row buttons-row">
            <div class="column">
              <button class="btn btn--longer" (click)="handleOkButton()">
                <p class="btn-title">
                  {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.BTN_OK_TITLE" | translate }}
                </p>
                <p class="btn-description">
                  {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.BTN_OK_DESCRIPTION" | translate }}
                </p>
              </button>
            </div>
            <div class="column">
              @if (!isBusiness) {
                @if (!vatDeclaration.premium_selected) {
                  <button class="btn btn--longer btn--primary btn-help" (click)="handleShowPremium()">
                    <p class="btn-title">
                      {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.BTN_HELP_TITLE" | translate }}
                    </p>
                    <p class="btn-description">
                      {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.BTN_HELP_DESCRIPTION" | translate }}
                    </p>
                  </button>
                }
                @if (vatDeclaration.premium_selected) {
                  <button class="btn btn--longer btn--primary btn-premium">
                    <p class="btn-title">
                      {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.BTN_PREMIUM_TITLE" | translate }}
                    </p>
                    <p class="btn-description">
                      {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.BTN_PREMIUM_DESCRIPTION" | translate }}
                    </p>
                  </button>
                }
              }
            </div>
          </div>
        </div>
      </div>
    }
    @if (incomeSumWarning) {
      <div class="deductions-info warning is_icon border-warning">
        <div class="deductions-info__wrap top">
          <div class="deductions-info__toltip-wrap alert_wrap">
            <img src="../../../../../../assets/svg/warning-icon.svg" class="alert_icon" />
          </div>
          <div class="deductions-info__wrap-text">
            <p class="deductions-info__text">
              {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.CLOSE_TO_LIMIT" | translate }}
            </p>
          </div>
        </div>
      </div>
    }
    @if (
      isNumber(vatDeclaration.income_sum) &&
      isNumber(vatDeclaration.last_year_income) &&
      !incomeSumWarning &&
      !incomeSumError &&
      !lastYearIncomeError &&
      statementYear >= 2025
    ) {
      <div class="deductions-info warning is_icon border-info info">
        <div class="deductions-info__wrap top">
          <div class="deductions-info__toltip-wrap alert_wrap">
            <img src="../../../../../../assets/svg/tooltip_icon.svg" class="alert_icon" />
          </div>
          <div class="deductions-info__wrap-text">
            <p class="deductions-info__text">
              {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.FAR_FROM_LIMIT" | translate }}
            </p>
          </div>
        </div>
      </div>
    }
  </div>
}
@if (vatDeclaration.declaration_type === declarationTypes.VAT_INCOME) {
  <div class="mv-30 smaller-title">
    <app-section-title
      [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.TAXATION_TYPE.QUESTION'"
      [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.TAXATION_TYPE.TOOLTIP_TITLE' | translate"
      [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.TAXATION_TYPE.TOOLTIP_TEXT' | translate"
    ></app-section-title>
    <div class="input-container no-border pv-16">
      <div class="row">
        <div class="column">
          <app-form-select
            [errors]="additionalIncomeService.getError('type_of_taxation')"
            [isVerification]="false"
            [employerStage]="true"
            [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.TAXATION_TYPE.PLACEHOLDER'"
            [(model)]="vatDeclaration.type_of_taxation"
            [choices]="taxationTypes"
            [valueName]="'id'"
            [optionName]="'name'"
            [isDisabled]="false"
            [currentIndex]=""
            [currentName]="'taxClass'"
            [addClassB2B]=""
            [classB2B]=""
          ></app-form-select>
        </div>
        <div class="column"> &nbsp; </div>
      </div>
    </div>
  </div>
  <div class="mv-16 smaller-title">
    <app-section-title
      [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.LABEL'"
      [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.TOOLTIP_TITLE' | translate"
      [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.TOOLTIP_TEXT' | translate"
    ></app-section-title>
    <app-simple-percent-field
      [errorKey]="'ai_general_rate_net_revenues'"
      [fieldsLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.INCOME1_LABEL'"
      [amountLabel]="'PRICE_TYPES.NET'"
      [resultLabel]="'PRICE_TYPES.VAT'"
      [percentValue]="19"
      [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"
      [isDisabled]="true"
      [initialAmount]="vatDeclaration.general_rate_net_revenues"
      (modelChange)="vatDeclaration.general_rate_net_revenues = $event"
      (calculatedChange)="updateVat('general_rate_net_revenues', $event)"
    ></app-simple-percent-field>
    <!--    <app-simple-percent-field-->
    <!--      [fieldsLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.INCOME2_LABEL'"-->
    <!--      [amountLabel]="'PRICE_TYPES.NET'"-->
    <!--      [resultLabel]="'PRICE_TYPES.VAT'"-->
    <!--      [percentValue]="19"-->
    <!--      [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"-->
    <!--      [isDisabled]="true"-->
    <!--    ></app-simple-percent-field>-->
  </div>
  <div class="mv-16 smaller-title">
    <app-section-title
      [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REDUCED_RATE.LABEL'"
      [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REDUCED_RATE.TOOLTIP_TITLE' | translate"
      [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REDUCED_RATE.TOOLTIP_TEXT' | translate"
    ></app-section-title>
    <app-simple-percent-field
      [errorKey]="'ai_reduced_rate_net_revenues'"
      [fieldsLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REDUCED_RATE.INCOME1_LABEL'"
      [amountLabel]="'PRICE_TYPES.NET'"
      [resultLabel]="'PRICE_TYPES.VAT'"
      [percentValue]="7"
      [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"
      [isDisabled]="true"
      [initialAmount]="vatDeclaration.reduced_rate_net_revenues"
      (modelChange)="vatDeclaration.reduced_rate_net_revenues = $event"
      (calculatedChange)="updateVat('reduced_rate_net_revenues', $event)"
    ></app-simple-percent-field>
    <!--    <app-simple-percent-field-->
    <!--      [fieldsLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REDUCED_RATE.INCOME2_LABEL'"-->
    <!--      [amountLabel]="'PRICE_TYPES.NET'"-->
    <!--      [resultLabel]="'PRICE_TYPES.VAT'"-->
    <!--      [percentValue]="7"-->
    <!--      [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"-->
    <!--      [isDisabled]="true"-->
    <!--    ></app-simple-percent-field>-->
  </div>
  <!--  <div class="mv-16 smaller-title">-->
  <!--    <app-section-title-->
  <!--      [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.OTHER_RATE.LABEL'"-->
  <!--      [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.OTHER_RATE.TOOLTIP_TITLE' | translate"-->
  <!--      [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.OTHER_RATE.TOOLTIP_TEXT' | translate"-->
  <!--    ></app-section-title>-->
  <!--    <app-optional-income-fields-->
  <!--      [fieldsLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.OTHER_RATE.INCOME1_LABEL'"-->
  <!--      [amountLabel]="'PRICE_TYPES.NET'"-->
  <!--      [resultLabel]="'PRICE_TYPES.VAT'"-->
  <!--      [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"-->
  <!--    ></app-optional-income-fields>-->
  <!--    <app-optional-income-fields-->
  <!--      [fieldsLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.OTHER_RATE.INCOME2_LABEL'"-->
  <!--      [amountLabel]="'PRICE_TYPES.NET'"-->
  <!--      [resultLabel]="'PRICE_TYPES.VAT'"-->
  <!--      [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"-->
  <!--    ></app-optional-income-fields>-->
  <!--  </div>-->
  <div class="input-container no-border mv-30 pv-16 bt-2">
    <div class="row">
      <div class="column center-v">
        <app-section-title
          [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.ZERO_RATE.LABEL'"
          [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.ZERO_RATE.TOOLTIP_TITLE' | translate"
          [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.ZERO_RATE.TOOLTIP_TEXT' | translate"
        ></app-section-title>
      </div>
      <div class="column">
        <div class="row">
          <div class="column">
            <app-form-input
              [errors]="additionalIncomeService.getError('zero_percent_net_revenues')"
              [label]="'PRICE_TYPES.NET'"
              [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"
              [(model)]="vatDeclaration.zero_percent_net_revenues"
            ></app-form-input>
          </div>
          <div class="column"> </div>
        </div>
      </div>
    </div>
  </div>
  <div class="input-container no-border mv-30 pv-16 bt-2">
    <mat-checkbox [(ngModel)]="vatDeclaration.reverse_charge">
      <app-section-title
        [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.LABEL'"
        [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.TOOLTIP_TITLE' | translate"
        [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.TOOLTIP_TEXT' | translate"
      ></app-section-title>
    </mat-checkbox>
    <div
      ><span>{{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.DESCRIPTION" | translate }}</span></div
    >
    @if (vatDeclaration.reverse_charge) {
      <app-complex-percent-field
        [amountErrorKey]="'ai_reverse_charge_first'"
        [percentErrorKey]="'ai_reverse_charge_first_vat_rate'"
        [fieldsLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.INCOME1_LABEL'"
        [amountLabel]="'PRICE_TYPES.NET'"
        [percentLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.VAT_RATE'"
        [resultLabel]="'PRICE_TYPES.VAT'"
        [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"
        [isDisabled]="true"
        [(initialAmount)]="vatDeclaration.reverse_charge_first"
        [(percentValue)]="vatDeclaration.reverse_charge_first_vat_rate"
        (vatChange)="updateVat('reverse_charge_first', $event)"
      ></app-complex-percent-field>
      <app-complex-percent-field
        [amountErrorKey]="'ai_reverse_charge_second'"
        [percentErrorKey]="'ai_reverse_charge_second_vat_rate'"
        [fieldsLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.INCOME2_LABEL'"
        [amountLabel]="'PRICE_TYPES.NET'"
        [percentLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.VAT_RATE'"
        [resultLabel]="'PRICE_TYPES.VAT'"
        [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"
        [isDisabled]="true"
        [(initialAmount)]="vatDeclaration.reverse_charge_second"
        [(percentValue)]="vatDeclaration.reverse_charge_second_vat_rate"
        (vatChange)="updateVat('reverse_charge_second', $event)"
      ></app-complex-percent-field>
      <app-complex-percent-field
        [amountErrorKey]="'ai_reverse_charge_third'"
        [percentErrorKey]="'ai_reverse_charge_third_vat_rate'"
        [fieldsLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.INCOME3_LABEL'"
        [amountLabel]="'PRICE_TYPES.NET'"
        [percentLabel]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.REVERSE_CHARGE.VAT_RATE'"
        [resultLabel]="'PRICE_TYPES.VAT'"
        [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"
        [isDisabled]="true"
        [(initialAmount)]="vatDeclaration.reverse_charge_third"
        [(percentValue)]="vatDeclaration.reverse_charge_third_vat_rate"
        (vatChange)="updateVat('reverse_charge_third', $event)"
      ></app-complex-percent-field>
    }
  </div>
  <div class="input-container no-border mv-30 pv-16 bt-2">
    <app-section-title
      [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SALES_VALUE.LABEL'"
      [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SALES_VALUE.TOOLTIP_TITLE' | translate"
      [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SALES_VALUE.TOOLTIP_TEXT' | translate"
    ></app-section-title>
    <div class="row">
      <div class="column left">
        <span>{{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SALES_VALUE.DESCRIPTION" | translate }}</span>
      </div>
      <div class="column right">
        <app-form-input
          [errors]="additionalIncomeService.getError('sales_value_settled_by_recipient')"
          [label]="'PRICE_TYPES.NET'"
          [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"
          [(model)]="vatDeclaration.sales_value_settled_by_recipient"
        ></app-form-input>
      </div>
    </div>
  </div>
  <div class="input-container no-border mv-30 pv-16 bt-2">
    <app-section-title
      [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.VAT_REFUND.LABEL'"
      [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.VAT_REFUND.TOOLTIP_TITLE' | translate"
      [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.VAT_REFUND.TOOLTIP_TEXT' | translate"
    ></app-section-title>
    <div class="row">
      <div class="column left">
        <span>{{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.VAT_REFUND.DESCRIPTION" | translate }}</span>
      </div>
      <div class="column right">
        <app-form-input
          [errors]="additionalIncomeService.getError('vat_refund_value')"
          [label]="'PRICE_TYPES.VAT'"
          [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"
          [(model)]="vatDeclaration.vat_refund_value"
          (modelChange)="updateVatRefund()"
        ></app-form-input>
      </div>
    </div>
  </div>
  <div class="input-container no-border mv-30 pv-16 bt-2">
    <app-section-title [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SUMMARY.LABEL'"></app-section-title>
    <div class="row">
      <div class="column left">
        <span>{{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SUMMARY.CALCULATED_LABEL" | translate }}</span>
      </div>
      <div class="column right">
        <app-form-input
          [placeholder]="''"
          [(model)]="totalVat"
          (modelChange)="recalcPaymentOrRefund()"
          [isDisabled]="true"
        ></app-form-input>
      </div>
    </div>
    <div class="row">
      <div class="column left">
        <span>{{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SUMMARY.ADVANCE_PAYMENTS_LABEL" | translate }}</span>
      </div>
      <div class="column right">
        <app-form-input
          [errors]="additionalIncomeService.getError('advance_payments')"
          [placeholder]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.GENERAL_RATE.PLACEHOLDER'"
          [(model)]="vatDeclaration.advance_payments"
          (modelChange)="recalcPaymentOrRefund()"
        ></app-form-input>
      </div>
    </div>
    <div class="row">
      <div class="column left">
        <span>{{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SUMMARY.PAYMENT_OR_REFUND_LABEL" | translate }}</span>
      </div>
      <div class="column right">
        <app-form-input [placeholder]="''" [(model)]="vatPayOrRefund" [isDisabled]="true"></app-form-input>
      </div>
    </div>
  </div>
  <div class="card card-white card-shadow mv-30 p-16 info-box">
    <app-section-title
      [title]="
        vatPayOrRefund > 0
          ? 'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SUMMARY.RESULT_INFO_PAY'
          : 'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SUMMARY.RESULT_INFO_REFUND'
      "
      [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SUMMARY.TOOLTIP_TITLE' | translate"
      [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.SUMMARY.TOOLTIP_TEXT' | translate"
    ></app-section-title>
  </div>
}
@if (!isBusiness) {
  <div class="card card-white card-shadow mv-30">
    <app-section-title
      [title]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.QUESTION'"
      [titleTooltip]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.TOOLTIP_TITLE' | translate"
      [message]="'ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.TOOLTIP_TEXT' | translate"
    ></app-section-title>
    <div class="mv-16"
      ><span>{{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.ANSWER" | translate }}</span></div
    >
    <div class="mv-16">
      @if (!vatDeclaration.premium_selected) {
        <button class="btn btn--longer btn--primary" (click)="handleGoPremium(true)">
          {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.BTN_TITLE" | translate }}
        </button>
      }
      @if (vatDeclaration.premium_selected) {
        <button class="btn btn--longer btn--primary btn-premium" (click)="handleGoPremium(false)">
          <p class="btn-title">
            {{ "ADDITIONAL_INCOME.VAT_DECLARATION_GROUP.PREMIUM.BTN_PREMIUM_TITLE" | translate }}
          </p>
        </button>
      }
    </div>
  </div>
}

<!-- TEMPLATES -->

<ng-template #steuernummer>
  <div class="input-container">
    <div class="row">
      <div class="column">
        <app-personal-info-tax-authority
          [taxAuthority]="vatDeclaration.tax_authority"
          (setTaxAuthority)="vatDeclaration.tax_authority = $event"
          [taxAuthorities]="dataSelects.taxAuthorities"
          [isLoading]="isTaxAuthorityLoading"
        ></app-personal-info-tax-authority>
        <app-validator-error-message
          [epValidator]="additionalIncomeService.epValidator"
          [index]="index"
          [fieldName]="additionalIncomeService.VALIDATOR_KEYS.tax_authority"
        ></app-validator-error-message>
      </div>
      <div class="column">
        <app-form-input
          [errors]="additionalIncomeService.getError('steuernummer')"
          [label]="'INPUT.STEUERNUMMER.LABEL'"
          [currentInputId]="'applicantSteuernummer'"
          [placeholder]="'INPUT.DEFAULT.PLACEHOLDER'"
          [(model)]="vatDeclaration.steuernummer"
          [classB2B]="'steuernr_input_pit'"
        ></app-form-input>
        <app-validator-error-message
          [epValidator]="additionalIncomeService.epValidator"
          [index]="index"
          [fieldName]="additionalIncomeService.VALIDATOR_KEYS.steuernummer"
        ></app-validator-error-message>
      </div>
    </div>
  </div>
</ng-template>
